(() => {
  if (window.afrCollectionNavigationReady) return;
  window.afrCollectionNavigationReady = true;
  const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('[data-afr-collection-rail]').forEach(rail => {
    const track = rail.querySelector('[data-afr-rail-track]');
    const previous = rail.querySelector('[data-afr-rail-previous]');
    const next = rail.querySelector('[data-afr-rail-next]');
    const update = () => {
      const distance = Math.abs(track.scrollLeft);
      const end = Math.max(0, track.scrollWidth - track.clientWidth);
      previous.disabled = distance < 2;
      next.disabled = distance >= end - 2;
    };
    const move = direction => {
      const sign = getComputedStyle(track).direction === 'rtl' ? -1 : 1;
      track.scrollBy({ left: track.clientWidth * direction * sign, behavior: reduced() ? 'auto' : 'smooth' });
    };
    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    track.addEventListener('scroll', update, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
    update();
  });
  const requestCollectionUpdate = (url, source) => {
    const detail = { url, source, handled: false };
    document.dispatchEvent(new CustomEvent('afr:collection-filter', { detail }));
    if (!detail.handled) window.location.assign(url);
  };
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-afr-tag-filters] a, [data-afr-tag-remove] a');
    if (!link || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const target = new URL(link.href, window.location.href);
    const current = new URL(window.location.href);
    current.searchParams.delete('page');
    current.searchParams.delete('section_id');
    current.searchParams.delete('sections');
    target.search = current.search;
    event.preventDefault();
    event.stopPropagation();
    requestCollectionUpdate(target.href, link);
  }, true);
  const container = document.querySelector('#ProductGridContainer');
  if (!container) return;
  const selected = { vendor: new Set(), type: new Set(), material: new Set() };
  const matchValue = (product, group, value) => {
    if (group !== 'material') return product[group] === value;
    if (Array.isArray(product[group])) return product[group].includes(value);
    return (product.tags || []).some(tag => tag === value || tag.endsWith(' ' + value) || tag.startsWith(value + ' '));
  };
  const matches = (product, ignoredGroup) => Object.entries(selected).every(([group, values]) =>
    group === ignoredGroup || !values.size || [...values].some(value => matchValue(product, group, value)));
  const renderSelections = () => {
    const applied = container.querySelector('[data-afr-applied-filters]');
    const chips = applied?.querySelector('[data-afr-local-chips]');
    if (!chips) return;
    chips.replaceChildren();
    Object.entries(selected).forEach(([group, values]) => values.forEach(value => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'afr-applied-chip';
      button.dataset.afrLocalRemove = group;
      button.dataset.afrValue = value;
      button.setAttribute('aria-label', applied.dataset.afrRemoveTemplate.replace('__VALUE__', value));
      const label = document.createElement('span');
      label.textContent = value;
      const close = document.createElement('span');
      close.textContent = '×';
      close.setAttribute('aria-hidden', 'true');
      button.append(label, close);
      chips.append(button);
    }));
    applied.hidden = applied.dataset.afrServerActive !== 'true' && applied.dataset.afrCatalogActive !== 'true' && !Object.values(selected).some(values => values.size);
  };
  const apply = (refreshServerCount = false) => {
    renderSelections();
    const host = document.querySelector('[data-afr-extra-filters]');
    const source = host?.querySelector('[data-afr-local-products]');
    const grid = container.querySelector('#ItemsGrid');
    if (!source) return;
    let products;
    try { products = JSON.parse(source.textContent); } catch (_) { return; }
    const byHandle = new Map(products.map(product => [product.handle, product]));
    const visibleProducts = [];
    let shown = 0;
    if (grid) [...grid.children].forEach(cell => {
      const link = cell.querySelector('a[href*="/products/"]');
      const handle = link ? new URL(link.href).pathname.split('/products/')[1]?.split('/')[0] : null;
      const product = byHandle.get(handle);
      if (!product) return;
      visibleProducts.push(product);
      const visible = matches(product);
      cell.toggleAttribute('data-afr-filtered-out', !visible);
      if (visible) shown++;
    });
    const active = Object.values(selected).some(values => values.size);
    document.querySelectorAll('[data-afr-local-filter]').forEach(input => {
      const group = input.dataset.afrLocalFilter;
      input.checked = selected[group].has(input.value);
      const count = visibleProducts.filter(product => matches(product, group) && matchValue(product, group, input.value)).length;
      input.disabled = !count && !input.checked;
      const countLabel = input.parentElement.querySelector('[data-afr-option-count]');
      if (countLabel) countLabel.textContent = '(' + count + ')';
    });
    document.querySelectorAll('[data-afr-local-reset]').forEach(button => { button.hidden = !active; });
    document.querySelectorAll('#ProductCount_header').forEach(count => {
      const serverCount = container.querySelector('[data-afr-applied-filters]')?.dataset.afrResultCount;
      if (refreshServerCount || !count.dataset.afrServerCount) count.dataset.afrServerCount = serverCount || count.textContent;
      const value = active ? host.dataset.afrCountTemplate.replace('__COUNT__', String(shown)) : count.dataset.afrServerCount;
      if (count.textContent !== value) count.textContent = value;
      count.setAttribute('aria-live', 'polite');
    });
    let empty = container.querySelector('[data-afr-local-empty]');
    if (!empty) {
      empty = document.createElement('p');
      empty.className = 'afr-local-filter-empty';
      empty.dataset.afrLocalEmpty = '';
      empty.setAttribute('role', 'status');
      container.append(empty);
    }
    empty.textContent = host.dataset.afrEmpty;
    empty.hidden = !active || shown > 0 || !grid;
  };
  ['input', 'change'].forEach(eventName => document.addEventListener(eventName, event => {
    const input = event.target.closest('[data-afr-local-filter]');
    if (!input) return;
    event.stopPropagation();
    if (eventName !== 'change') return;
    const values = selected[input.dataset.afrLocalFilter];
    if (!values || input.disabled) return;
    if (input.checked) values.add(input.value); else values.delete(input.value);
    apply();
  }, true));
  document.addEventListener('click', event => {
    const remove = event.target.closest('[data-afr-local-remove]');
    const clearAll = event.target.closest('[data-afr-clear-all]');
    const reset = event.target.closest('[data-afr-local-reset]');
    if (!remove && !clearAll && !reset) return;
    event.preventDefault();
    event.stopPropagation();
    if (remove) {
      selected[remove.dataset.afrLocalRemove]?.delete(remove.dataset.afrValue);
      apply();
      return;
    }
    Object.values(selected).forEach(values => values.clear());
    if (clearAll) {
      const current = new URL(window.location.href);
      const target = new URL(clearAll.href, current);
      const hasServerFilters = current.pathname !== target.pathname || [...current.searchParams.keys()].some(key => key.startsWith('filter.'));
      target.search = current.search;
      [...target.searchParams.keys()].filter(key => key.startsWith('filter.') || ['page', 'section_id', 'sections'].includes(key)).forEach(key => target.searchParams.delete(key));
      if (hasServerFilters) {
        requestCollectionUpdate(target.href, clearAll);
        return;
      }
    }
    apply();
  }, true);
  document.addEventListener('afr:filters-updated', () => apply(true));
  new MutationObserver(records => {
    if (records.some(record => record.target.id === 'ItemsGrid' || record.target === container && [...record.addedNodes].some(node => node.nodeType === 1 && !node.hasAttribute('data-afr-local-empty')))) apply(true);
  }).observe(container, { childList: true, subtree: true });
  apply();
})();
